import React from 'react';
import { makeStyles } from '@mui/styles';
import { Container } from '@mui/material';
// import { OutlinedInput as MuiOutlinedInput } from '@mui/material';
// import InputAdornment from '@mui/material/InputAdornment';
// import Search from '@mui/icons-material/Search';

import Styles from './Header.styles';
import { styled } from '@mui/system';

const useStyles = makeStyles(Styles);

const Logo = styled('div')(({ theme }) => ({
  '> *': {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      maxHeight: '48px',
      '@media (max-width:780px)': {
        maxHeight: '24px',
      },
    },
  },
}));

const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  // maxWidth: '1224px',
  width: '100%',
  // marginLeft: '-8px',
  '@media (max-width:1220px)': {
    marginLeft: '0px',
  },
}));

const Actions = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

const Header = ({ type, logo, actions, isApp = false }) => {
  const classes = useStyles();

  const containerPaddingClasses = isApp
    ? classes.containerPaddingApp
    : classes.containerPadding;
  const containerColorClasses =
    type === 'dark' ? classes.containerDark : classes.containerLight;
  const containerClasses = `${classes.containerNavbar} ${containerColorClasses}`;

  return (
    <div className={containerClasses}>
      <div className={containerPaddingClasses}>
        <Container
          maxWidth={isApp ? false : 'xl'}
          className={classes.containerContent}
        >
          <Content>
            {logo && <Logo>{logo}</Logo>}
            {actions && (
              <Actions>
                {actions.map((a, i) => (
                  <div key={i}>{a}</div>
                ))}
              </Actions>
            )}
          </Content>
        </Container>
      </div>
    </div>
  );
};

export default Header;
